export const SET_CURRENT_CAMPAIGN = 'SET_CURRENT_CAMPAIGN'
